import { Route, Routes } from "react-router-dom";
import 'aos/dist/aos.css';
import { ThemeProvider } from "./contexts/ThemeContext";

import Navbar from "./components/Navbar";

import "./index.css";
import Layout from "./pages/Layout";
import Aos from "aos";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    Aos.init();
  }, []);

  return (
    <ThemeProvider>
      <div className="w-[100%] md:w-[90%] md:mx-auto select-none bg-white text-gray-900">
        <Navbar />
        <Routes>
          <Route path="/" element={<Layout />} />
        </Routes>
      </div>
    </ThemeProvider>
  );
}

export default App;
